module.exports = __webpack_public_path__ + "static/media/text_title_romanian.7afd2204.svg";